import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { usePageActions } from "@/modules/pages/hooks/usePageActions";
import { useWidgetActions } from "@/modules/widgets/hooks/useWidgetActions";
import { Page } from "@/modules/pages";

/**
 * Global hook for page updates
 * Coordinates state updates across involved modules
 */
export function usePageGlobalOperations() {
    const router = useRouter();
    const { setCurrentPage } = usePageActions();
    const { setWidgets } = useWidgetActions();

    const selectCurrentPage = useCallback(
        (page: Page) => {
            setCurrentPage(page);
            setWidgets(page.widgets ?? []);
            const params = new URLSearchParams(window.location.search);
            params.set("pageId", page.id.toString());
            router.replace(`/dashboard?${params.toString()}`);
        },
        [setCurrentPage, setWidgets]
    );

    return { selectCurrentPage };
}
